import React from "react";

const TrailOverviewStage = props => {
    const {trailDetails = {}, readOnly = false, progressMode = false} = props;
    const baseDivProps = {
        className: progressMode
            ? "pw-results js-pw-dashboard"
            : "pw-builder js-pw-builder",
        ...(progressMode && { "data-read-only": readOnly })
    };

    return (
        <div {...baseDivProps}>
            {trailDetails.pathwayId && (
                <input type="hidden" name="pathway.pathwayId" value={trailDetails.pathwayId}/>
            )}
            {trailDetails.pathwayAssignmentId && (
                <input type="hidden" name="pathway.pathwayAssignmentId" value={trailDetails.pathwayAssignmentId}/>
            )}
            {trailDetails.pathwayType && (
                <input type="hidden" name="pathway.pathwayType" value={trailDetails.pathwayType}/>
            )}
            {trailDetails.conceptSpecific && (
                <input type="hidden" name="pathway.conceptSpecific" value={trailDetails.conceptSpecific}/>
            )}
            {trailDetails.trailAssignmentId && (
                <input type="hidden" name="trailAssignmentId" value={trailAssignmentId}/>
            )}
            {trailDetails.conceptId && (
                <input type="hidden" name="conceptId" value={trailDetails.conceptId}/>
            )}
            <div className={"pw-b-stageBlk js-pw-b-stageBlk" + (readOnly || progressMode ? "" : " pw-b-stage-edit")}>
                <div className="pw-b-stage-dragFirst">
                    <div className="pw-b-s-infoBlk">Drag first activity here</div>
                </div>
                {/*<div className="pw-b-stage-updateingIcon"></div>*/}
                <div className="pw-b-stageWrap">
                    <div className="pw-b-stage js-pw-b-stage"></div>
                </div>
            </div>
            {!readOnly && !progressMode && (
                <div className="pw-b-resources">
                    <div className="cont-split">
                        <div className="cont-split-block-c">
                            <h3 className="text-article-title pw-text-article-title">Activities</h3>
                            <div className="pw-b-r-itemsBlk js-pw-b-resources"></div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default TrailOverviewStage;